<div class="pm-v2-page">
  <div class="card card-statistics mb-30">
    <div class="card-body"><h4 class="mb-0">ثبت اجرای PM</h4></div>
  </div>

  <div class="card card-statistics mb-30" *ngIf="Context as context">
    <div class="card-header"><strong>اطلاعات تجهیز و برنامه PM</strong></div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-4"><strong>تجهیز:</strong> {{ context.Equipment_Code || '-' }}</div>
        <div class="col-md-8"><strong>نام تجهیز:</strong> {{ context.Equipment_Name || '-' }}</div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-4 mb-2"><strong>کد قالب :</strong> {{ context.Template_Code || '-' }}</div>
        <div class="col-md-8 mb-2"><strong>نام قالب :</strong> {{ context.Template_Name || '-' }}</div>
        <div class="col-md-12 mb-2"><strong>توضیحات قالب:</strong> {{ context.Description || '-' }}</div>
        <div class="col-md-6 mb-2"><strong>فعالیت:</strong> {{ context.Activity_Name || '-' }}</div>
        <div class="col-md-3 mb-2"><strong>نوع:</strong> {{ context.Type_Item || '-' }}</div>
        <div class="col-md-3 mb-2"><strong>دوره:</strong> {{ context.Frequency != null ? context.Frequency + ' روز' : '-' }}</div>
        <div class="col-md-6 mb-2"><strong>معیار پذیرش:</strong> {{ context.AcceptanceCriteria || '-' }}</div>
        <div class="col-md-6 mb-2"><strong>دستور انجام:</strong> {{ context.Instruction || '-' }}</div>
        <div class="col-md-12"><strong>سررسید:</strong> {{ formatPersianDate(Due) }}</div>
      </div>
    </div>
  </div>

  <form [formGroup]="Form">
    <div class="card card-statistics mb-30">
      <div class="card-header"><strong>ثبت نتیجه اجرا</strong></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 form-group">
            <label>نتیجه *</label>
            <select class="custom-select" formControlName="Result">
              <option value="">انتخاب کنید</option>
              <option value="Pass">Pass</option>
              <option value="Fail">Fail</option>
              <option value="NA">N/A</option>
            </select>
          </div>
          <div class="col-md-4 form-group">
            <label>تاریخ اجرا</label>
            <input type="text" #datepickerExecution placeholder="اینجا تایپ کنید ..." class="form-control">
            <ng-persian-datepicker style="position: absolute; z-index: 5;" [timeEnable]="false"
              [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerExecution"></ng-persian-datepicker>
            <small class="form-text text-muted">اگر خالی باشد Backend زمان جاری را ثبت می‌کند.</small>
          </div>
          <div class="col-md-4 form-group">
            <label>مقدار عددی</label>
            <input type="number" class="form-control" formControlName="Numeric_Value">
          </div>
          <div class="col-md-6 form-group">
            <label>مقدار / نتیجه متنی</label>
            <textarea rows="3" class="form-control" formControlName="Text_Value"></textarea>
          </div>
          <div class="col-md-6 form-group">
            <label>توضیحات</label>
            <textarea rows="3" class="form-control" formControlName="Comment"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="text-left">
      <button type="button" style="margin-left: 5px;" class="btn btn-warning ml-2" (click)="Back()"><i class="fa fa-mail-reply"></i> بازگشت</button>
      <button type="button" class="btn btn-success" [disabled]="Procssing" (click)="Save(datepickerExecution.value)">
        {{ Procssing ? 'در حال ثبت...' : 'ثبت اجرا' }}
      </button>
    </div>
  </form>
</div>
